import serviceToken from './requestToken';

const RETAILER_BASE_API = process.env.REACT_APP_RETAILER_BASE_API;

export interface PromotionBannerData {
  id: string;
  title?: string;
  effective_date: string;
  end_date: string;
}

export interface DownloadLinkResponse {
  download_url: string;
}

/**
 * Fetch promotion banner information
 */
export const getPromotionBannerSvc = async (): Promise<PromotionBannerData[]> => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + `banner/promotion`,
    {
      params: {}
    }
  );
  return res.data;
};

/**
 * Get CSV download link for a specific promotion event
 * @param eventId - The promotion event ID
 */
export const getPromotionDownloadLinkSvc = async (
  eventId: string
): Promise<DownloadLinkResponse> => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + `banner/promotion/csv-download-link`,
    {
      params: { event_id: eventId }
    }
  );
  return res.data;
};

/**
 * Fetch price review banner information
 */
export const getPriceReviewBannerSvc = async () => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + `banner/price-review`,
    {
      params: {}
    }
  );
  return res.data;
};

/**
 * Get download link for a specific price review
 * @param priceReviewId - The price review ID
 */
export const getPriceReviewDownloadLinkSvc = async (
  priceReviewId: string
): Promise<DownloadLinkResponse> => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + `banner/price-review/download-link`,
    {
      params: { price_review_id: priceReviewId }
    }
  );
  return res.data;
};
